<template>
  <div>
    <v-treeview ref="cabinet-pattern-treeview" open-all :items="pattern" style="text-align: left; padding-left: 50px">
      <template #append="{item}">
        <v-row no-gutters align="center" style="width: 280px">
          <v-col cols="auto" style="position: absolute; left: -30px">
            <v-btn v-if="!disableEdit && item && hasAdd(item)" fab color="success" @click="addChild(item)" x-small>
              <v-icon color="white" :size="15">
                mdi-plus
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template #label="{item}">
        <template v-if="item.level === 1"> {{ item.name }} </template>
        <template v-else-if="item.level === 2">
          <v-row no-gutters align="center">
            <v-col cols="auto" class="pr-1"> {{ item.name }} </v-col>
            <v-col cols="auto" :style="`color: ${$_colors.fontlight}`"> {{ `(${item.value})` }} </v-col>
            <v-col cols="auto" class="pl-12">
              <v-icon v-if="!disableEdit && item && hasDelete(item)" color="error" @click="deleteChild(item)">
                mdi-close
              </v-icon>
            </v-col>
          </v-row>
        </template>
      </template>
    </v-treeview>
  </div>
</template>
<script>
export default {
  name: 'ZDMCabinetPatternTreeview',
  props: {
    pattern: {
      type: Array,
      default: () => [],
    },
    disableEdit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    hasAdd(item) {
      return item.level === 1;
    },
    hasDelete(item) {
      return item.level === 2 && item.value === this.pattern[0]?.children.length;
    },
    addChild(item) {
      if (item.level === 1) {
        if (!item.children) item.children = [];
        item.children.push({
          name: this.$i18n.t('admin.circuit'),
          value: item.children.length + 1,
          level: 2,
        });
      }
    },
    deleteChild(item) {
      if (item.level === 2) {
        this.pattern[0]?.children.pop();
      }
    },
  },
};
</script>
